export default __webpack_public_path__ + "static/media/ve_4.469dc4c7.mp3";